import * as React from 'react'

import { ICommonLocation } from '../../../common/utils/location/types'
import { IItem } from '../../../typings/searchResults'
import SearchResultsBody from '../../pages/search/result/searchResultBody'

import * as styles from './itemsGrid.module.css'

interface IProps {
  items: IItem[]
  location: ICommonLocation
  listName: string
  showSingleRow?: boolean
}

const ItemsGrid = ({ items, location, listName, showSingleRow }: IProps) => {
  return (
    <div className={styles.grid}>
      <SearchResultsBody
        location={location}
        matches={items}
        listName={listName}
        viewType="grid"
        showSingleRow={showSingleRow}
      />
    </div>
  )
}

export default ItemsGrid
